import { useState } from 'react'

import Button from './ButtonOld'
import Label from './Label'
import Modal from './Modal'
import Spinner from './Spinner'

interface IProps {
  email
  open
  onClose
  spinnerLive
  onSubmit
}

const EmailAddressModalForm: React.FC<IProps> = ({
  email,
  open,
  onClose,
  spinnerLive,
  onSubmit,
}) => {
  const [emailAddress, setEmailAddress] = useState<string | undefined>(email)

  const updateEmailAddress = (e) => {
    e.preventDefault()

    if (emailAddress) {
      onSubmit(emailAddress)
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Update email address"
      footerAction={<Button title="Confirm" onClick={updateEmailAddress} disabled={spinnerLive} />}
    >
      {spinnerLive ? (
        <Spinner />
      ) : (
        <form onSubmit={updateEmailAddress}>
          <Label>Email Address</Label>
          <input
            onChange={(e) => setEmailAddress(e.target.value)}
            type="email"
            value={emailAddress}
            className="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md w-full"
          />
        </form>
      )}
    </Modal>
  )
}

export default EmailAddressModalForm
